/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { useModalOPPromptContext } from '@/components/ModalOPPromptContext';
import { Actionable, Text } from '@az/starc-ui';
import { useLabels } from '@/hooks/useLabels';
import styles from './styles.module.scss';
import { useCopyPromoCode } from '../../hooks/useCopyPromoCode';

const labelMap = {
  useExclusiveOfferPart1: 'label_use_exclusive_offer_part1',
  useExclusiveOfferPart2: 'label_use_exclusive_offer_part2',
  at: 'label_promotext_at',
};

export const PromoCode = () => {
  const labels = useLabels(labelMap);
  const { offer } = useModalOPPromptContext();
  const { handleCopyPromoCode } = useCopyPromoCode();

  return (
    <>
      <Text variant="large-body" className={styles.promoPartOne}>
        {labels.useExclusiveOfferPart1}{' '}
        <Actionable className={styles.promoCode} onClick={handleCopyPromoCode}>
          {offer?.promoCode}
        </Actionable>{' '}
        {labels.at}
      </Text>
      <Text className={styles.promoPartTwo}>{labels.useExclusiveOfferPart2}</Text>
    </>
  );
};
